import type { ApiEndpoint } from "@/shared/api-endpoint";
import { isObject } from "@/shared/utils/typeGuards";

export const kStemSplitterRoute = "/stem-splitter";

export interface StemSplitterRequestBody {
    audioKey: string;
}

export const isStemSplitterRequestBody = (value: unknown): value is StemSplitterRequestBody =>
    isObject(value) && typeof value.audioKey === "string";

export interface StemSplitterSuccessResponse {
    ok: true;
    vocalsUrl: string;
    drumsUrl: string;
    bassUrl: string;
    otherUrl: string;
}

export const isStemSplitterSuccessResponse = (
    value: unknown,
): value is StemSplitterSuccessResponse =>
    isObject(value) &&
    value.ok === true &&
    typeof value.vocalsUrl === "string" &&
    typeof value.drumsUrl === "string" &&
    typeof value.bassUrl === "string" &&
    typeof value.otherUrl === "string";

export const kStemSplitterEndpoint: ApiEndpoint<
    StemSplitterRequestBody,
    StemSplitterSuccessResponse
> = {
    route: kStemSplitterRoute,
    label: "Stem Splitter",
    source: "Atlantis",
    category: "Stem Separation",
    description:
        "Splits a full mix into four isolated stems — vocals, drums, bass, and other — using the Atlantis stem-splitter model.",
    isRequestBody: isStemSplitterRequestBody,
    isSuccessResponse: isStemSplitterSuccessResponse,
};
